export enum TableStatusEnum {
  confirmed = 'confirmed',
  completed = 'completed',
  inProgress = 'in_progress',
  canceled = 'canceled',
  comingSoon = 'comingSoon',
  recentlyCompleted = 'recently_completed'
}
